
const Cookie = require('js-cookie');

const showFileName = (str, limit=25, substr=13) => {
    if (str.length > limit) {
        return str.substr(0, substr) + ' ... ' + str.substr(str.length-substr, str.length)
    }
    return str
}

const ClearSession = () => {
    Cookie.remove('auth');
}

const GetSession = () => {
    let auth = Cookie.get('auth')
  return (auth) ? JSON.parse(auth):null
}

const SaveSession = ( data ) => {
    Cookie.set('auth', JSON.stringify(data));
}

export default {
    BASE_URL: process.env.VUE_APP_API_URL,
    showFileName,
    SaveSession,
    GetSession,
    ClearSession
}
